import { create } from 'zustand';

const useAuthStore = create((set, get)=>({
        isLoggedIn: false,
        isInitializing: true,
        user: null,
        userLoading: false,
        userError: null,
        userLastFetched: null,
        // Actions for user management
        setIsLoggedIn: (isLoggedIn)=>set({
                isLoggedIn
            }),
        setUser: (user)=>set({
                user,
                userError: null,
                userLastFetched: user ? Date.now() : null
            }),
        setUserLoading: (loading)=>set({
                userLoading: loading
            }),
        setUserError: (error)=>set({
                userError: error
            }),
        clearUser: ()=>set({
                user: null,
                userError: null,
                userLastFetched: null
            })
    }));

export { useAuthStore as default };
//# sourceMappingURL=auth.store.js.map
